export default __webpack_public_path__ + "static/media/newsletter_blank.fb990ef5.jpg";